import React from 'react';
import Modal from './Modal';
import '../modals/ModalForms.css';

const ConfirmDialog = ({
  isOpen,
  title = 'Confirmar',
  message = '¿Estás seguro?',
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  onConfirm,
  onCancel,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title={title}
      contentClassName="modal-content-confirm"
      contentStyle={{ marginBottom: '25vh' }}
      onEnter={onConfirm}
      footer={(
        <div className="modal-footer">
          <div className="footer-actions" style={{ marginLeft: 'auto' }}>
            <button className="btn secondary" onClick={onCancel}>{cancelLabel}</button>
            <button className="btn danger" onClick={onConfirm}>{confirmLabel}</button>
          </div>
        </div>
      )}
    >
      <p>{message}</p>
    </Modal>
  );
};

export default ConfirmDialog;
